import 'date-fns';
import React from 'react';
import {LocalizationProvider, DatePicker} from '@mui/x-date-pickers';
import FormControl from '@mui/material/FormControl';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import deLocale from "date-fns/locale/es";
import {useStyles} from './style';
import { FormHelperText, TextField } from '@mui/material';

export default function FormSelectorDeFechas(props) {
    const classes = useStyles(props);

    const normalizarFecha = (value) => {
        if (!value) return null;

        if (value instanceof Date) {
            if (Number.isNaN(value.getTime())) return null;
            return new Date(value.getFullYear(), value.getMonth(), value.getDate());
        }

        if (typeof value !== 'string') return null;

        const valor = value.trim();
        if (!valor) return null;

        const matchDMY = valor.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
        if (matchDMY) {
            const day = Number(matchDMY[1]);
            const month = Number(matchDMY[2]) - 1;
            const year = Number(matchDMY[3]);
            const parsed = new Date(year, month, day);

            if (
                parsed.getFullYear() === year &&
                parsed.getMonth() === month &&
                parsed.getDate() === day
            ) {
                return parsed;
            }

            return null;
        }

        const matchYMD = valor.match(/^(\d{4})[/-](\d{1,2})[/-](\d{1,2})$/);
        if (matchYMD) {
            const year = Number(matchYMD[1]);
            const month = Number(matchYMD[2]) - 1;
            const day = Number(matchYMD[3]);
            const parsed = new Date(year, month, day);

            if (
                parsed.getFullYear() === year &&
                parsed.getMonth() === month &&
                parsed.getDate() === day
            ) {
                return parsed;
            }

            return null;
        }

        const parsed = new Date(valor);
        if (Number.isNaN(parsed.getTime())) return null;

        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    };

    const parsearFechaDDMMYYYY = (value) => {
        if (typeof value !== 'string') return null;
        const valor = value.trim();
        const match = valor.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (!match) return null;

        const day = Number(match[1]);
        const month = Number(match[2]) - 1;
        const year = Number(match[3]);
        const parsed = new Date(year, month, day);

        if (
            parsed.getFullYear() === year &&
            parsed.getMonth() === month &&
            parsed.getDate() === day
        ) {
            return parsed;
        }

        return null;
    };

    const valorNormalizado = normalizarFecha(props.value);
    const minDateNormalizada = normalizarFecha(props.minDate);
    const maxDateNormalizada = normalizarFecha(props.maxDate);

    return (
        <>
        {props?.showInputDate && (
        <FormControl className={classes.formControl} >
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={deLocale} >
                <DatePicker
                    disableFuture={props.disableFuture}
                    views={props.views}
                    variant="inline"
                    inputFormat="dd/MM/yyyy"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id={props.name}
                    name={props.name}
                    key={props.name}
                    label={props.label}
                    value={valorNormalizado}
                    disablePast={props.disablePast}
                    maxDate={maxDateNormalizada}
                    minDate={minDateNormalizada}
                    disabled={props.disabled}
                    closeOnSelect={true}
                    onChange={(date, keyboardInputValue)=>{
                        let valorFecha = normalizarFecha(date);

                        // En escritura manual, no aceptamos valores parciales porque el
                        // adapter de fechas puede interpretar fragmentos como años válidos.
                        if (typeof keyboardInputValue === 'string') {
                            const valorEscrito = keyboardInputValue.trim();

                            if (valorEscrito.length === 0) {
                                valorFecha = null;
                            } else if (valorEscrito.length === 10) {
                                valorFecha = parsearFechaDDMMYYYY(valorEscrito);
                            } else {
                                return;
                            }
                        }

                        props.handleChange({"target":{"name":props.name,"value":valorFecha}})
                        if(props?.manejadorDeCambio) props.manejadorDeCambio({"target":{"name":props.name,"value":valorFecha}})
                    }}
                    KeyboardButtonProps={{ 'aria-label': 'change date' }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            helperText={null}
                        />
                    )}
                />
            </LocalizationProvider>
            {(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
        </FormControl>
        )}
    </>
    )
}

FormSelectorDeFechas.defaultProps = {
    disableFuture: false,
    disablePast: false,
    views: ['year', 'month', 'day'],
    showInputDate: true
}